module.exports = __webpack_public_path__ + "static/media/amazon-review.661d75ad.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Home/amazon-review.gif
// module id = ./src/assets/Home/amazon-review.gif
// module chunks = 0